<template>
  <div class="panel-body">
      <slot></slot>
  </div>
</template>

<script>
export default {
  name: "panel-body"
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Panel/PanelBody.vue